<template>
  <v-form ref="form" class="d-flex align-baseline">
    <v-file-input
      :label="this.$t('data-export-upload.select-file-to-upload')"
      v-model="file"
      accept="text/xml"
      :rules="[rules.required, isXml]"
      show-size
      class="flex-grow-1"
      :readonly="readonly"
    ></v-file-input>
    <v-btn
      :loading="loading"
      v-on:click="upload"
      class="ml-2 flex-shrink-0"
      color="primary"
      upload
      :disabled="readonly"
      >{{ $t("data-export-upload.upload") }}</v-btn
    >
  </v-form>
</template>

<script>
import { rules } from "../../../mixins/rules";
import { projectPermissions } from "../../../mixins/projects/projectPermissions";

export default {
  name: "UploadDmeFile",
  mixins: [rules, projectPermissions],
  data: () => ({
    file: null,
    loading: false
  }),
  computed: {
    readonly: {
      get() {
        return !this.hasCurrentProjectPermissions("project.update");
      }
    }
  },
  methods: {
    isXml: function(val) {
      return (
        (val && val.type === "text/xml") ||
        this.$t("data-export-upload.is-not-xml")
      );
    },
    upload() {
      if (this.$refs.form.validate()) {
        let params = {
          project_id: this.$route.params.project_id,
          export_file: this.file
        };
        this.loading = true;
        this.$store
          .dispatch("projectAccountingStore/dmeFileStore/create", {
            params: params
          })
          .then(() => {
            this.file = null;
            this.$refs.form.reset();
          })
          .finally(() => (this.loading = false));
      }
    }
  }
};
</script>

<style scoped></style>
